<template>
  <div>
    <template v-if="loading">
      <content-placeholders>
        <content-placeholders-text :lines="10"/>
      </content-placeholders>
    </template>
    <template v-else-if="items.length">
      <div class="catalog-view__box">
        <div class="catalog-view__box-head">
          <div class="catalog-view__subtitle" id="media">Полезные материалы <span
              v-if="items.length > 1"> {{ items.length }}</span></div>
          <a class="catalog-view__link catalog-view__link--lg" @click="showModal">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 15L5 18H19V15" stroke="#00AC86" stroke-width="2"/>
              <path d="M15 11L12.0707 13.9293C12.0317 13.9683 11.9683 13.9683 11.9293 13.9293L9 11" stroke="#00AC86"
                    stroke-width="2" stroke-linecap="square"/>
              <line x1="12" y1="14" x2="12" y2="5" stroke="#00AC86" stroke-width="2"/>
            </svg>
            <span>Скачать все</span>
          </a>
        </div>
        <div class="catalog-view__table catalog-view__table-docs">
          <table>
            <thead>
            <tr>
              <th>Наименование</th>
              <th>Дата обновления</th>
              <th>Тип</th>
              <th colspan="2">Размер</th>
            </tr>
            </thead>
            <tbody>
            <tr v-show="key < 5 || showAll" v-for="(item, key) in items" :key="key">
              <td>{{ item.name }}</td>
              <td> {{ item.updated_at || '-' }}</td>
              <td> {{ getType(item.type) || '-' }}</td>
              <td> {{ item.filesize }}</td>
              <td>
                <a class="catalog-view__link" :href="item.downloadLink">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 15L5 18H19V15" stroke="#00AC86" stroke-width="2"/>
                    <path d="M15 11L12.0707 13.9293C12.0317 13.9683 11.9683 13.9683 11.9293 13.9293L9 11"
                          stroke="#00AC86" stroke-width="2" stroke-linecap="square"/>
                    <line x1="12" y1="14" x2="12" y2="5" stroke="#00AC86" stroke-width="2"/>
                  </svg>
                  <span>Скачать</span>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="catalog-view__docs-mobile">
          <div class="catalog-view__mobile-item" v-show="key < 5 || showAll" v-for="(item, key) in items" :key="key">
            <div class="catalog-view__mobile-head">
              <div class="catalog-view__mobile-title">{{ item.name }}</div>
              <a class="catalog-view__img-link" :href="item.downloadLink">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 15L5 18H19V15" stroke="#00AC86" stroke-width="2"/>
                  <path d="M15 11L12.0707 13.9293C12.0317 13.9683 11.9683 13.9683 11.9293 13.9293L9 11" stroke="#00AC86"
                        stroke-width="2" stroke-linecap="square"/>
                  <line x1="12" y1="14" x2="12" y2="5" stroke="#00AC86" stroke-width="2"/>
                </svg>
              </a>
            </div>
            <div class="catalog-view__mobile-row">
              <div class="catalog-view__mobile-col">Обновлено</div>
              <div class="catalog-view__mobile-col">
                {{ item.updated_at || '-' }}
              </div>
            </div>
            <div class="catalog-view__mobile-row">
              <div class="catalog-view__mobile-col">Тип</div>
              <div class="catalog-view__mobile-col">{{ getType(item.type) || '-' }}</div>
            </div>
            <div class="catalog-view__mobile-row">
              <div class="catalog-view__mobile-col">Размер</div>
              <div class="catalog-view__mobile-col">{{ item.filesize }}</div>
            </div>
          </div>
        </div>
        <div v-if="items.length > 5" class="catalog-view__show-more" @click="toggle()">
          <span v-if="!showAll">Развернуть</span>
          <span v-if="showAll">Свернуть</span>
          <svg v-if="!showAll" width="16" height="16" viewBox="0 0 16 16" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M12 6L7.99999 10.5L4 6" stroke="#00AC86" stroke-width="2"></path>
          </svg>
          <svg v-if="showAll" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 11L8 6.49998L4 11" stroke="#00AC86" stroke-width="2"></path>
          </svg>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import {getType} from '@/common/mediaType'
import {EVENT_ADD_CHIPS} from "../../views/ProductCard";

export default {
  name: 'media',
  components: {},
  props: {
    product_id: {
      require: true
    }
  },
  data: () => ({
    items: [],
    loading: true,
    showAll: false
  }),
  created() {
    this.$api.product.media(this.product_id).then((response) => {
      if (response && response.data) {
        this.items = response.data
        if (this.items.length) {
          this.$emit(EVENT_ADD_CHIPS, {
            link: 'media',
            title: 'Полезные материалы',
            size: this.items.length,
            order: 6
          })
        }
      }
      this.loading = false
    }).catch(() => {
      this.loading = false
    })
  },
  methods: {
    getType,
    showModal() {
      this.$root.$emit('product-archive-modal::show', {
        categories: [
          "catalogs",
          "tech-docs",
          "scheme_2d",
          "drawing_2d",
          "bim_model",
          "tech_article",
          "letter",
          "edu_documentation",
          "distribution_kit",
          "update_kit",
          "firmware_kit",
          "ies_ldt",
          "projects",
          "guide",
          "passport",
          "configuration"
        ]
      })
    },
    toggle() {
      this.showAll = !this.showAll
    }
  }
}
</script>